const About = () => (
  <div className="container mx-auto p-8">
    <h2 className="text-3xl font-bold mb-4">About HackHub</h2>
    <p className="text-lg">
      HackHub is a vibrant coding club where enthusiasts gather to learn, share, and innovate.
    </p>
  </div>
);

export default About;
